<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer">
      <div class="row justify-content-center mh-100vh">
        <div class="text-center">
          <h4 class="pt-3">Best Wishes on Your Wedding.</h4>
          <p class="pt-3" style="white-space:break-spaces; font-size:larger">お打ち合わせいただきありがとうございました
おふたりのフラワーコーディネートが素敵になりますよう
精一杯ご準備させていただきます
当日までどうぞよろしくお願いいたします
          </p>
        </div>

        <div><img class="w-100" :src="imageUrl"></div>
      </div>
    </CustomerMeetingLayout>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import mstore from '@/store/meeting-store'
import cstore from '@/store/customer-store'

export default {
  name: 'CustomerMeetingFinish',
  components: { CommonLayout, CustomerMeetingLayout, CommonModal },
  data () {
    return {
      imageUrl: '',
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getSignalingData: function (newData, oldData) {
      if (newData['event'] === 'click') {
        if (newData['id'] === 'prev') {
          this.$router.push(newData['target_path'])
        }
        if (newData['id'] === 'priceHide') {
          cstore.commit('setCustomerDisplayFlag', false)
          this.customerDisplayFlag = cstore.getters.customerDisplayFlag
        } else if (newData['id'] === 'priceDisplay') {
          cstore.commit('setCustomerDisplayFlag', true)
          this.customerDisplayFlag = cstore.getters.customerDisplayFlag
        }
      }
    }
  },
  mounted () {
    // sessionStorageの最終遷移ページ・操作件を削除
    sessionStorage.removeItem('lastRoutePath')
    sessionStorage.removeItem('customerIsOperationPossible')
    localStorage.removeItem('tabInfo')

    this.imageUrl = this.config.imageURL + '/meeting-contents/mtg-finish.jpg'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingFinish.vue